import styled from "@emotion/styled";
import { Card } from "@mui/material";

export const CardInterrupcao = styled(Card)`
    margin-bottom: 1rem;

    &:last-child {
        margin-bottom: 0;
    }
`